export default __webpack_public_path__ + "static/hostaway-8dc66cc8828e2c790de554f9dfb53e07.svg";